<template>
  <ul class="menu-nav" >
    <router-link  v-for="menu in menuData"
      :to="{ name: menu.name }"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="$permissions.businesses.read && menu.ifshow"
    >
      <li
        class="menu-item menu-item-submenu"
        :class="{ 'menu-item-active': isActive || isExactActive }"
      >
        <a class="menu-link" :href="href" @click="navigate">
          <span class="menu-text font-weight-bolder">{{menu.title}} </span>
        </a>
      </li>
    </router-link>
    <!-- <router-link
      :to="{ name: 'logs' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="false"
    >
      <li
        class="menu-item menu-item-submenu"
        :class="{ 'menu-item-active': isActive || isExactActive }"
      >
        <a class="menu-link" :href="href" @click="navigate">
          <span class="menu-text font-weight-bolder">Logs</span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ name: 'analytics' }"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        class="menu-item menu-item-submenu"
        :class="{ 'menu-item-active': isActive || isExactActive }"
      >
        <a class="menu-link" :href="href" @click="navigate">
          <span class="menu-text font-weight-bolder">Analytics</span>
        </a>
      </li>
    </router-link> -->
  </ul>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return{
      menuData:[
        {
          title:'Companies',
          name:'companies',
          ifshow:true 

        },
        {
          title:'Logs',
          name:'logs',
          ifshow:false

        },
        {
          title:'Analytics',
          name:'analytics',
          ifshow:true

        },
        {
          title:'Platform Stats',
          name:'platformStats',
          ifshow:true

        },
        {
          title:'Cohort Analysis',
          name:'cohortAnalysis',
          ifshow:true

        },
        {
          title:'Monthly Numbers',
          name:'monthlydata',
          ifshow:true

        },
      ]
    }
  }
};
</script>
